import EROS_EXT_1 from "./EROS_EXT_1";

export default {
  EROS_EXT_1,
};
